import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vhire/vhire/v4-frontend/src/app/(app)/jobs/[slug]/job-detail-client.tsx");
